<template>
  <div class="bankid-signed-container">
    <BankIdLogo class="bankid-confirm-logo" />
    <FriedH3>{{ $t('bankid-is-signed') }}</FriedH3>
    <div class="bankid-signed-inner-container">
      <FriedParagraph>{{ $t('you-will-soon-be-sent-to-next-step') }}</FriedParagraph>
      <FriedSpinner :size="30" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BankIdLogo from '../../../assets/bankid.svg';

export default defineComponent({
  name: 'BankIdSigned',
  components: {
    BankIdLogo,
  },
});
</script>

<style lang="scss" scoped>
.bankid-signed-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-100);

  .bankid-confirm-logo {
    height: 5rem;
    width: 5rem;
  }

  .bankid-signed-inner-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-50);
  }
}
</style>
